import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "../../services/utility/autoMapperService";
import BaseListComponent from "../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../components/tableComponents/itemsTable";
import TableFilterPane from "../../components/tableComponents/tableFilterPane";
import lasIndividualAndCorporateLoanReportService from "../../services/report/lasIndividualAndCorporateLoanReportService";

export interface LASLoanRequestReportProps { }

export interface LASLoanRequestReportState
  extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class LASLoanRequestReportList extends BaseListComponent<LASLoanRequestReportState> { }

class LASLoanRequestReport extends React.Component<
  LASLoanRequestReportProps,
  LASLoanRequestReportState
> {
  constructor(props: LASLoanRequestReportProps) {
    super(props);
    this.state = {
      data: createFilterData([
        "date",
        "loanType",
        "status"
      ]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "date", fieldType: "date", value: "" },
        {
          name: "loanType",
          fieldType: "select",
          options: [
            "Individual",
            "Corporate",
            "Group"
          ],
          value: ""
        },
        {
          name: "status",
          fieldType: "select",
          options: [
            "Created",
            "Rejected",
            "Pending",
            "Completed"
          ],
          value: ""
        }
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    data = typeof data === "undefined" ? this.state.data : data;
    var dataFilter = this.getFilteredItems(data)
    this.setState({ fetching: true });
    try {
      const reportItems = await lasIndividualAndCorporateLoanReportService.filterLoanRequestReport(
        pageSize,
        currentPage,
        dataFilter
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: reportItems.data.data,
          properties: [
            { oldName: "customerNAme", newName: "customerName" },
            { oldName: "loanAmount", newName: "loanAmount" },
            {
              isTag: true,
              oldName: "loanType",
              newName: "loanType",
              primary: "Individual",
              secondary: "Corporate",
              success: "Group",
            },
            { oldName: "phoneNumber", newName: "phoneNumber" },
            {
              isTag: true,
              oldName: "gender",
              newName: "gender",
              light: "Male",
              dark: "Female"
            },
            {
              isTag: true,
              oldName: "maritalStatus",
              newName: "maritalStatus",
              default: "Single",
              primary: "Married",
              secondary: "Divorced",
              warning: "Other",
              light: "Widowed"
            },
            { oldName: "date", newName: "dateCreated" },
            {
              isTag: true,
              oldName: "status",
              newName: "status",
              success: "Completed",
              primary: "Created",
              warning: "Pending",
              danger: "Rejected"
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: reportItems.data.totalCount,
        fetching: false,
      });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
      } else {
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async (type: string) => { };

  fetchItemById = async (item: any) => { };

  getFilteredItems = (data: IFilterData) => {
    let filteredItems = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key].item2;
      }
    });
    return filteredItems;
  };

  getFilteredItemsText = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>LAS Loan Request Report</b>
              </h3>
            </div>
            <LASLoanRequestReportList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([
                  "date",
                  "loanType",
                  "status"
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [
                  { name: "date", fieldType: "date", value: "" },
                  {
                    name: "loanType",
                    fieldType: "select",
                    options: [
                      "Individual",
                      "Corporate",
                      "Group"
                    ],
                    value: ""
                  },
                  {
                    name: "status",
                    fieldType: "select",
                    options: [
                      "Created",
                      "Rejected",
                      "Pending",
                      "Completed"
                    ],
                    value: ""
                  }
                ],
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({ }) => (<></>)}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItemsText(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="LAS Loan Request Report"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={["loanAmount"]}
                              timeColumn={["dateCreated"]}
                              disableViewDetails={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></LASLoanRequestReportList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default LASLoanRequestReport;
